<template>
  <span class="review-utility-button">
    <v-menu offset-y transition="slide-y-transition">
      <template #activator="{ on, attrs }">
        <button v-bind="attrs" v-on="on" class="menu-button">
          <v-icon :size="iconSize">mdi-dots-horizontal</v-icon>
        </button>
      </template>
      <v-list class="utility-menu">
        <!-- v-dialog confirms deletion of post -->
        <v-dialog v-model="deleteDialog" width="500">
          <template #activator="{ on, attrs }">
            <v-list-item v-if="post.username === username" v-bind="attrs" v-on="on">
              <span class="red--text">Delete</span>
            </v-list-item>
          </template>

          <v-card>
            <v-card-text> Are you sure you want to delete this post? </v-card-text>
            <v-card-actions>
              <v-btn @click="deleteDialog = false"> No </v-btn>
              <v-spacer />
              <v-btn
                @click="
                  deleteReview(post.id);
                  deleteDialog = false;
                "
              >
                Yes
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-list-item
          v-if="post.username === username"
          :to="{
            name: 'review',
            params: { id: post.id },
            query: { edit: true },
          }"
          color="danger"
        >
          Edit
        </v-list-item>

        <v-list-item
          v-if="post.username !== username"
          @click="
            showReportPopup({
              contentId: post.id,
              contentType: 'review',
            })
          "
        >
          <span class="red--text">Report Post</span>
        </v-list-item>

        <v-list-item> Cancel </v-list-item>
      </v-list>
    </v-menu>
  </span>
</template>

<script>
import { mapMutations } from "vuex";
import deleteReview from "../mixins/deleteReview";
export default {
  name: "review-utility-button.vue",
  mixins: [deleteReview],

  props: {
    iconSize: Number,
    post: {
      username: String,
      id: Number,
    },
  },

  computed: {
    username() {
      return this.$store.state.username;
    },
  },

  data: function () {
    return {
      deleteDialog: false,
    };
  },

  methods: {
    ...mapMutations(["showSnackbar", "showReportPopup"]),
  },
};
</script>
